"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_router_dom_1 = require("react-router-dom");
const react_redux_1 = require("react-redux");
const routes_1 = require("../constants/routes");
const sampleAppController_1 = require("../../facetec/src/sampleAppController");
const ui_1 = require("../reducers/slices/ui");
const user_1 = require("../reducers/slices/user/user");
const update_user_thunk_1 = require("../reducers/slices/user/thunks/update_user_thunk");
const doshx_controls_web_1 = require("doshx_controls_web");
const facetecBypass_1 = require("../helpers/facetecBypass");
const FaceTecGate = () => {
    const navigate = (0, react_router_dom_1.useNavigate)();
    const location = (0, react_router_dom_1.useLocation)();
    const [searchParams] = (0, react_router_dom_1.useSearchParams)();
    const dispatch = (0, react_redux_1.useDispatch)();
    const userChoseFaceTec = searchParams.get("method") === "facetec";
    const { user } = (0, react_redux_1.useSelector)((state) => state.userState);
    const { enrolled, facetecDatabaseReference, loginAuthenticated, authenticationInProgress, enrollmentInProgress, facetecSDKReady, facetecError, showQrAuthModal } = (0, react_redux_1.useSelector)((state) => state.uiState);
    const [cameraSupported, setCameraSupported] = (0, react_1.useState)(null);
    const [cameraPermissionDenied, setCameraPermissionDenied] = (0, react_1.useState)(false);
    const [cameraCheckComplete, setCameraCheckComplete] = (0, react_1.useState)(false);
    // Clear stale error on mount so each visit to FaceTecGate starts fresh
    (0, react_1.useEffect)(() => {
        if (facetecError) {
            dispatch((0, ui_1.clearFacetecError)());
        }
    }, []); // eslint-disable-line react-hooks/exhaustive-deps
    // BYPASS (CRM pattern): Set loginAuthenticated in Redux so ProtectedRoute allows through.
    // Navigation is handled by the existing loginAuthenticated useEffect below.
    // This covers: test mode (ENABLE_TEST_AUTH), bypass_skysign_auth permission, and mobile access.
    (0, react_1.useEffect)(() => {
        if (!(user === null || user === void 0 ? void 0 : user._id))
            return;
        if (loginAuthenticated)
            return; // Already authenticated
        if (!(0, facetecBypass_1.shouldBypassFaceTec)())
            return;
        // Set auth state so ProtectedRoute allows through
        if (!enrolled) {
            dispatch((0, ui_1.enrollmentCompleted)());
        }
        dispatch((0, ui_1.faceTecAuthenticated)());
        dispatch((0, user_1.setFaceTecAuthorized)(true));
    }, [user === null || user === void 0 ? void 0 : user._id, loginAuthenticated, enrolled, dispatch]);
    // Determine mode: enrollment or authentication
    const needsEnrollment = (0, react_1.useMemo)(() => {
        return !(user === null || user === void 0 ? void 0 : user.facetecDBRef);
    }, [user === null || user === void 0 ? void 0 : user.facetecDBRef]);
    // Track if we've already synced facetecDBRef to prevent loops
    const syncedRefRef = (0, react_1.useRef)(null);
    // Trigger FaceTec flow when SDK ready (only on first attempt — errors stop auto-retry)
    (0, react_1.useEffect)(() => {
        if (!(user === null || user === void 0 ? void 0 : user._id))
            return;
        if (!facetecSDKReady)
            return;
        if (!cameraCheckComplete)
            return;
        // BYPASS CHECK: Don't start FaceTec if bypass is active (test mode / permission / mobile)
        if ((0, facetecBypass_1.shouldBypassFaceTec)()) {
            return;
        }
        // STOP auto-retry when there's an error — user must explicitly retry
        if (facetecError) {
            return;
        }
        if (needsEnrollment) {
            if (!enrollmentInProgress && !enrolled) {
                dispatch((0, ui_1.startEnrollment)());
                sampleAppController_1.SampleApp.onEnrollUserPressed();
            }
        }
        else if (!loginAuthenticated && !authenticationInProgress) {
            if (userChoseFaceTec && cameraSupported === true && !cameraPermissionDenied) {
                // User explicitly chose FaceTec from the modal — start it
                dispatch((0, ui_1.authenticateFaceTec)());
                sampleAppController_1.SampleApp.onAuthenticateUserPressed(user.facetecDBRef);
            }
            else {
                // Show QR/FaceTec selection modal — user picks their auth method
                dispatch((0, ui_1.resetAuthenticationInProgress)());
                if (!showQrAuthModal) {
                    dispatch((0, ui_1.showQrAuth)());
                }
            }
        }
    }, [
        user === null || user === void 0 ? void 0 : user._id,
        facetecSDKReady,
        needsEnrollment,
        loginAuthenticated,
        enrolled,
        facetecError,
        dispatch,
        cameraSupported,
        cameraPermissionDenied,
        cameraCheckComplete,
        userChoseFaceTec,
    ]);
    // Track if we've already saved to prevent duplicate API calls
    const savedRefRef = (0, react_1.useRef)(null);
    // Persist facetecDBRef after enrollment to database
    (0, react_1.useEffect)(() => {
        if (!(user === null || user === void 0 ? void 0 : user._id))
            return;
        if (!enrolled)
            return;
        if (!facetecDatabaseReference)
            return;
        // Don't save if already saved this reference
        if (savedRefRef.current === facetecDatabaseReference)
            return;
        savedRefRef.current = facetecDatabaseReference;
        // Update user in database with facetecDBRef
        dispatch((0, update_user_thunk_1.update_user_thunk)({
            data: Object.assign(Object.assign({}, user), { facetecDBRef: facetecDatabaseReference }),
        }));
    }, [enrolled, facetecDatabaseReference, user === null || user === void 0 ? void 0 : user._id]);
    // Sync facetecDBRef from user state to UI slice if it exists
    (0, react_1.useEffect)(() => {
        if ((user === null || user === void 0 ? void 0 : user.facetecDBRef) && user.facetecDBRef !== syncedRefRef.current) {
            syncedRefRef.current = user.facetecDBRef;
            dispatch((0, ui_1.setFacetecDatabaseReference)(user.facetecDBRef));
        }
    }, [user === null || user === void 0 ? void 0 : user.facetecDBRef]);
    // Navigate back after successful authentication
    (0, react_1.useEffect)(() => {
        var _a, _b;
        if (!(user === null || user === void 0 ? void 0 : user._id))
            return;
        if ((user === null || user === void 0 ? void 0 : user.facetecDBRef) && loginAuthenticated) {
            dispatch((0, user_1.setFaceTecAuthorized)(true));
            dispatch((0, ui_1.hideQrAuth)());
            const fromPath = (_b = (_a = location.state) === null || _a === void 0 ? void 0 : _a.from) === null || _b === void 0 ? void 0 : _b.pathname;
            // Check URL query params for document return (set by QrAuthModal "Start Facial Recognition" button)
            const returnTo = searchParams.get("return_to");
            const documentId = searchParams.get("document_id");
            const docType = searchParams.get("type");
            let dest;
            const sanitise = (v) => v.replace(/[^a-zA-Z0-9_-]/g, "");
            if (returnTo === "document" && documentId) {
                const safeId = sanitise(documentId);
                const safeType = docType ? `/${sanitise(docType)}` : "";
                dest = `${routes_1.CONSOLE_ROUTE}${routes_1.DOCUMENT_ROUTE}/${safeId}${safeType}`;
            }
            else if (fromPath && fromPath !== "/face-tec") {
                dest = fromPath;
            }
            else {
                dest = routes_1.CONSOLE_ROUTE;
            }
            navigate(dest, { replace: true });
        }
    }, [user === null || user === void 0 ? void 0 : user._id, user === null || user === void 0 ? void 0 : user.facetecDBRef, loginAuthenticated, navigate, location.state, dispatch, searchParams]);
    // Detect camera availability/permission
    (0, react_1.useEffect)(() => {
        let cancelled = false;
        const detectCamera = () => __awaiter(void 0, void 0, void 0, function* () {
            var _a, _b;
            if (!("mediaDevices" in navigator) || !((_a = navigator.mediaDevices) === null || _a === void 0 ? void 0 : _a.enumerateDevices)) {
                if (!cancelled) {
                    setCameraSupported(false);
                    setCameraCheckComplete(true);
                }
                return;
            }
            try {
                const devices = yield navigator.mediaDevices.enumerateDevices();
                const hasVideoInput = devices.some((d) => d.kind === "videoinput");
                if (!cancelled)
                    setCameraSupported(hasVideoInput);
                if ("permissions" in navigator && ((_b = navigator.permissions) === null || _b === void 0 ? void 0 : _b.query)) {
                    try {
                        const status = yield navigator.permissions.query({ name: "camera" });
                        if (!cancelled) {
                            setCameraPermissionDenied(status.state === "denied");
                        }
                        status.onchange = () => {
                            if (!cancelled) {
                                setCameraPermissionDenied(status.state === "denied");
                            }
                        };
                    }
                    catch (_) {
                        // ignore
                    }
                }
            }
            catch (_) {
                if (!cancelled)
                    setCameraSupported(false);
            }
            finally {
                if (!cancelled)
                    setCameraCheckComplete(true);
            }
        });
        detectCamera();
        return () => {
            cancelled = true;
        };
    }, []);
    // Handler: retry FaceTec (clears error and lets useEffect re-trigger)
    const handleRetry = () => {
        dispatch((0, ui_1.clearFacetecError)());
    };
    // Handler: re-enrol (clear facetecDBRef from Redux so enrollment flow starts)
    const handleReEnrol = () => {
        dispatch((0, ui_1.clearFacetecError)());
        dispatch((0, ui_1.resetFaceTecAuth)());
        dispatch((0, update_user_thunk_1.update_user_thunk)({
            data: Object.assign(Object.assign({}, user), { facetecDBRef: null }),
        }));
    };
    // Handler: log out and go to sign-up
    const handleGoToSignUp = () => {
        navigate(routes_1.WELCOME_ROUTE + routes_1.SIGN_UP_ROUTE, { replace: true });
    };
    // Error state — show notification instead of looping
    if (facetecError) {
        const isEnrolmentError = facetecError.toLowerCase().includes("not found") || facetecError.toLowerCase().includes("re-enrol");
        return (react_1.default.createElement("div", { className: "h-full w-full flex items-center justify-center bg-backgroundColor" },
            react_1.default.createElement("div", { className: "flex flex-col items-center gap-4 text-center max-w-md px-6" },
                react_1.default.createElement("div", { className: "w-16 h-16 rounded-full bg-red-100 flex items-center justify-center" },
                    react_1.default.createElement("span", { className: "text-red-500 text-2xl" }, "!")),
                react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: "Authentication Issue", size: "xlarge", textColor: "text-primary", bold: true }),
                react_1.default.createElement("div", { className: "text-sm text-gray-600 px-4" }, facetecError),
                react_1.default.createElement("div", { className: "flex flex-col gap-3 w-full mt-2" },
                    react_1.default.createElement(doshx_controls_web_1.ButtonControl, { label: "Try Again", backgroundColor: "bg-primary", textColor: "text-white", onClick: handleRetry }),
                    isEnrolmentError && (react_1.default.createElement(doshx_controls_web_1.ButtonControl, { label: "Re-enrol Facial Recognition", backgroundColor: "bg-secondary", textColor: "text-white", onClick: handleReEnrol })),
                    react_1.default.createElement(doshx_controls_web_1.ButtonControl, { label: "Authenticate with mobile app (QR)", backgroundColor: "bg-gray-200", textColor: "text-gray-700", onClick: () => {
                            dispatch((0, ui_1.resetAuthenticationInProgress)());
                            dispatch((0, ui_1.showQrAuth)());
                        } }),
                    react_1.default.createElement(doshx_controls_web_1.ButtonControl, { label: "Sign Up / Register", backgroundColor: "bg-gray-100", textColor: "text-gray-500", onClick: handleGoToSignUp })),
                react_1.default.createElement("div", { className: "text-xs text-gray-400 mt-2" }, "If this issue persists, please contact support."))));
    }
    return (react_1.default.createElement("div", { className: "h-full w-full flex items-center justify-center bg-backgroundColor" },
        react_1.default.createElement("div", { className: "flex flex-col items-center gap-4 text-center" },
            react_1.default.createElement(doshx_controls_web_1.CircularLoaderControl, { size: "large" }),
            react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: facetecSDKReady
                    ? needsEnrollment
                        ? "Preparing Facial Recognition enrolment..."
                        : "Starting face scan for authentication..."
                    : "Preparing Facial Recognition...", size: "large", textColor: "text-secondary" }),
            (cameraSupported === false || cameraPermissionDenied) && (react_1.default.createElement("div", { className: "text-sm text-orange-600 px-4" }, cameraSupported === false
                ? "No camera detected on this device. Use the mobile app QR option to continue."
                : "Camera permission denied. Use the mobile app QR option or enable camera access to authenticate with Facial Recognition.")),
            react_1.default.createElement(doshx_controls_web_1.ButtonControl, { label: "Authenticate with mobile app (QR)", backgroundColor: "bg-primary", textColor: "text-white", onClick: () => {
                    dispatch((0, ui_1.resetAuthenticationInProgress)());
                    dispatch((0, ui_1.showQrAuth)());
                } }),
            react_1.default.createElement("p", { id: "status", "aria-live": "polite", className: "sr-only" }, facetecSDKReady ? "Processing..." : "Initializing..."))));
};
exports.default = FaceTecGate;
